// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2eYtS","disabled":"FileBtn_disabled__2LM1r","warn":"FileBtn_warn__3wZgy","fade":"FileBtn_fade__3y9rf"};